import { createRouter, createWebHistory } from "vue-router";
import Homeview from "@/router/home.vue";
import Memberview from "@/router/member.vue";
import Adminview from "@/router/admin.vue";
import Customerview from "@/router/customer.vue";
import Userview from "@/router/user.vue";
import Inetview from "@/router/inettie.vue";
import Estimateview from "@/router/estimate.vue";
import Erpview from "@/router/erp.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Homeview,
  },
  {
    path: "/admin",
    name: "Admin",
    component: Adminview,
  },
  {
    path: "/member",
    name: "Member",
    component: Memberview,
  },
  {
    path: "/customer",
    name: "Customer",
    component: Customerview,
  },

  {
    path: "/user",
    name: "User",
    component: Userview,
  },
  {
    path: "/inet",
    name: "Inettie",
    component: Inetview,
    meta: { requiresAuth: true },
  },
  {
    path: "/estimate",
    name: "Estimate",
    component: Estimateview,
    meta: { requiresAuth: true },
  },
  {
    path: "/erp",
    name: "Erp",
    component: Erpview,
    meta: { requiresAuth: true },
  },
  {
    path: "/agw",
    component: () => import("@/router/agwlayout.vue"),
    children: [
      {
        path: "",
        name: "agwMain",
        component: () => import("@/router/agw.vue"),
      },
    ],
  },

  {
    path: "/smile",
    component: () => import("@/router/smilelayout.vue"),
    children: [
      {
        path: "",
        name: "smile",
        component: () => import("@/router/smile.vue"),
      },
    ],
  },

  {
    path: "/smilelist",
    name: "SmileList",
    component: () => import("@/router/smilelist.vue"),
  },

  {
    path: "/sungho",
    name: "Sungho",
    component: () => import("@/router/sungho.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

function hasValidSession() {
  const token = (localStorage.getItem("token") || "").trim();
  const expiresAt = Number(localStorage.getItem("tokenExpiresAt") || 0);
  return Boolean(token && expiresAt && Date.now() <= expiresAt);
}

router.beforeEach((to, from, next) => {
  if (!to.meta?.requiresAuth) {
    next();
    return;
  }

  if (hasValidSession()) {
    next();
    return;
  }

  next({
    path: "/sungho",
    query: { redirect: to.fullPath || "/inet" },
  });
});

export default router;
